'use strict';

module.exports = function(app) {

    app.showPassword = function (button) {
        $(button).siblings('input').attr('type', 'text');
    };

    app.hidePassword = function (button) {
        $(button).siblings('input').attr('type', 'password');
    };

    return app;
};
